export const COLLECTION_SCREEN_KEYS = [
  "phone-number",
  "phone-otp",
  "legal-name",
  "dob-nationality",
  "address-search",
  "address-manual",
  "ssn",
  "due-diligence",
  "enhanced-due-diligence",
  "document-upload",
  "selfie-upload",
  "proof-of-address",
] as const;

export const KYC_SCREEN_KEYS = ["verify-identity", ...COLLECTION_SCREEN_KEYS] as const;

export type KycScreenKey = (typeof KYC_SCREEN_KEYS)[number];
